import * as Yup from "yup";
import {yupRequiredString} from "../yup/Validators";

export const CreateCommentSchema = Yup.object().shape({
  content: yupRequiredString
})